import React, { useEffect } from "react";
import FlipCardSlider from "../../components/Slider/FlipCardSlider";
import ArticleContainer from "../../components/Article/ArticleContainer";
import ArticleHero from "../../components/Hero/ArticleHero";

const relatedBlogs = [
  {
    contentType: "BLOG",
    title: "Complimenting Fleet Modernization with Road Safety",
    description:
      "Shoora is leading the charge in transforming fleet operations by enhancing safety and operational efficiency through the Voluntary Vehicle-Fleet Modernization Programme (VVMP).",
    link: "/insights/blog/complimenting-fleet-modernization-with-road-safety",
    linkText: "Read article",
    thumbnail:
      "https://images.pexels.com/photos/11389692/pexels-photo-11389692.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    readTime: 10,
  },
  {
    contentType: "BLOG",
    title: "Envisioning the Future of Mobility with Shoora",
    description:
      "Shoora offers comprehensive fleet management solutions that track vehicle locations, monitor driver performance, optimise routes, and reduce fuel consumption.",
    thumbnail: "/images/thumbnails/14.jpeg",
    link: "/insights/blog/envisioning-the-future-of-mobility-with-shoora",
    readTime: 10,
  },
  {
    contentType: "BLOG",
    title: "Leverage AIS-140’s Mandate for Telematics Devices",
    description:
      "Shoora, a leader in advanced video telematics solutions , is committed to harnessing the potential of this mandate to create safer roads and smarter transportation systems.",
    thumbnail: "https://www.easyembedded.net/images/ais2.jpg",
    link: "/insights/blog/how-shoora-aims-to-leverage-ais-140s-mandate-for-telematics-devices-in-public-transportation-and-commercial-vehicles",
    readTime: 10,
  },

  {
    contentType: "BLOG",
    title: "Truck Driver Safety Tips: A Guide to Protecting Lives on the Road",
    description:
      "Shoora, through its advanced video telematics solutions, is helping to curb these numbers and protect lives.",
    thumbnail:
      "https://images.pexels.com/photos/27946843/pexels-photo-27946843/free-photo-of-truck-rearview-mirror.jpeg?auto=compress&cs=tinysrgb&w=600",
    link: "/insights/blog/truck-driver-safety-tips-a-guide-to-protecting-lives-on-the-road",
    readTime: 10,
  },
  {
    contentType: "CUSTOMER STORY",
    title: "Shoora Life Savers Helped BLR Logistics Avert Over 7,500 Accidents",
    description:
      "Shoora is not just a service provider for BLR Logistics; they are a trusted safety partner.",
    thumbnail:
      "https://images.jdmagicbox.com/v2/comp/mumbai/26/022p1955726/catalogue/blr-logistics-india-ltd-goregaon-east-mumbai-transporters-for-all-india-3m98o5wutw.jpg",
    link: "/insights/customer-stories/how-shoora-life-savers-helped-blr-logistics-avert-over-7500-accidents",
    readTime: 10,
  },

  {
    contentType: "CUSTOMER STORY",
    title: "Kapoor Diesels Truck Achieves 1,60,200 Accident-Free Kilometres",
    description:
      "The integrated suite of technologies offered Kapoor Diesel enhanced safety, better fleet management, and measurable cost savings.",
    thumbnail: "/images/thumbnails/15.jpeg",
    link: "/insights/customer-stories/kapoor-diesel-fleet-achieves-60200-accident-free-kilometres-with-shooras-cutting-edge-video-telematics-solutions",
    readTime: 10,
  },
];
const data = {
  contentType: "BLOG",
  title: "Tackling Distracted Driving: Transforming Fleet Safety",
  description:
    "Moving into a new world of software-defined, service-driven digital mobility.",
  author: "Shoora",
  createdOn: "26th Oct, 2024",
  imgsrc: "/images/thumbnails/3.jpeg",
  readTime: 10,
  content: ` 
             <p>
        Distracted driving remains a silent threat on our roads, responsible for
        countless accidents daily. Defined by the CDC as any activity diverting
        attention from driving, it can be <strong>visual</strong> (eyes off the
        road), manual (hands off the wheel), or <strong>cognitive</strong> (mind
        off driving). Texting while driving is particularly dangerous as it
        combines all three distractions, with drivers covering the length of a
        football field in just five seconds of inattention.
        <br />
        <br />
        For fleet operators, the stakes are even higher-accidents result in
        injuries, operational delays, financial losses, and damage to
        reputation.
      </p>

      <h2>Shoora’s Strategy to Eliminate Distractions</h2>
      <p>
        Shoora's <strong>CabIn Vision™</strong> and <strong>RoadSense™</strong>
        systems, backed by its 24/7 <strong>Control Room</strong> team, are
        setting new standards for fleet safety. By adopting the
        <strong>Three Ts—Talk, Train, and Track</strong>, Shoora addresses
        distracted driving head-on, protecting lives and optimising operations.
      </p>

      <h5>Talk: Start the Conversation</h5>
      <p>
        Shoora fosters a culture of awareness by opening clear lines of
        communication:
      </p>
      <ul>
        <li>
          Drivers are educated on how distractions impact their safety and that
          of others.
        </li>
        <li>
          The financial and human costs of accidents are discussed to highlight
          the importance of focus.
        </li>
      </ul>

      <h5>Train: Coaching On the Go</h5>
      <p>
        Shoora’s cutting-edge tools ensure drivers receive timely and impactful
        guidance:
      </p>
      <ul>
        <li>
          <strong>AI-Powered Dash Cams</strong> monitor risky behaviours like
          using mobile phones, smoking, or showing signs of fatigue.
        </li>
        <li>
          Alerts are delivered instantly in regional languages for easy
          understanding.
        </li>
        <li>
          When critical alerts are detected, Shoora’s Control Room team steps in
          with real-time, two-way communication to provide instant coaching and
          corrective advice.
        </li>
      </ul>

      <h5>Track: Leverage Data for Safer Roads</h5>
      <p>
        Shoora’s technology offers comprehensive monitoring to improve fleet
        safety:
      </p>
      <ul>
        <li>
          Advanced dash cams capture high-definition footage for real-time
          visibility into driver behaviour.
        </li>
        <li>
          Alerts for lane drifting, unsafe proximity, and potential collisions
          allow proactive interventions.
        </li>
        <li>
          Detailed analytics help fleet managers identify patterns and fine-tune
          training for lasting behavioural changes.
        </li>
      </ul>

      <h2>Proven Impact: Lives Saved, Risks Reduced</h2>
      <p>
        With Shoora’s solutions in action, companies like BLR Logistics have
        prevented <strong>over 7,500 potential accidents</strong> in just one
        year. Drivers are not only becoming safer but are also benefiting from
        ongoing guidance and support, ensuring they remain focused and confident
        on the road.
      </p>

      <h2>Driving Toward a Safer Future</h2>
      <p>
        Distracted driving is entirely preventable, but it requires a strategic
        approach combining awareness, training, and technology. Shoora’s
        innovative systems and proactive
        <strong>Life Savers Control Room</strong> make fleets safer while
        delivering peace of mind to operators.
        <br />
        <br />
        For organisations ready to prioritise safety, Shoora offers more than
        just a tool-it’s a trusted partner in creating a distraction-free
        journey for all.
      </p>`,
};
const TacklingDistractedDriving = () => {
  useEffect(()=> {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  },[]);
  return (
    <>
      <ArticleHero
        contentType={data?.contentType}
        title={data?.title}
        createdOn={data?.createdOn}
        imgsrc="/images/about/bg8.webp"
      />
      <div className="bg-dark">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a href="#">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a href="#">Insights</a>
              </li>
              <li class="breadcrumb-item">
                <a href="#" className="text-capitalize">
                  {data?.contentType}s
                </a>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                {data?.title}
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <ArticleContainer data={data} />
      <hr className="border-3" style={{ borderColor: "var(--accent-color)" }} />
      <div
        className="stories-section section my-5"
        style={{ maxWidth: "100%" }}
      >
        <div className="container">
          <FlipCardSlider data={relatedBlogs} title={"You may also like"} />
        </div>
      </div>
    </>
  );
};

export default TacklingDistractedDriving;
